import React, { useState } from "react";
import { Typography, Button } from "@material-ui/core";
import { useSelector } from 'react-redux';
import { RootStateOrAny } from 'react-redux';
import { Constants } from '../constants/Constants';
import { NumberUtils } from '../utils/NumberUtils';
import { Redirect } from "react-router-dom";
import Routes from "../constants/Routes";
import { OperationStatus } from "../enums/OperationStatus";
import { useCookies } from "react-cookie";
import { LoginState } from '../enums/AuthState';

export default function EnterTheFutureOfInvestmentView() {

    const registeredUsersCount = useSelector((state: RootStateOrAny) => state.appReducer[Constants.REGISTERED_USERS_COUNT]);
    const [navigateToLogin, setNavigateToLogin] = useState(false);
    const [, setCookie] = useCookies([Constants.ACTIVE_OPERATION_STATUS]);
    const logInState: LoginState = useSelector((state: RootStateOrAny) => state.appReducer[Constants.LOGIN_STATE]);

    const initAuth = () => {
        setCookie(Constants.ACTIVE_OPERATION_STATUS, OperationStatus.DEFAULT)
        setNavigateToLogin(true);
    }
    
    return (
        <div style={{
            marginTop: 40,
            background: `url(${require('./../images/diamond_pattern.png')})`,
        }}>
            <div style={{
                height: 250,
                backgroundColor: '#121d33c4',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                padding: 40
            }}>
                <Typography
                    style={{
                        color: 'white',
                        fontSize: 30,
                        textAlign: 'center',
                        fontWeight: 400,
                    }} dangerouslySetInnerHTML={{ __html: `Join <b>${NumberUtils.formatInThousands(registeredUsersCount)}</b> other users` }} />
                <Typography style={{
                    fontSize: 17,
                    paddingTop: 10,
                    textAlign: 'center',
                    color: '#d8d8d8'
                }}>To Earn, Multiply and Win Free Bitcoins</Typography>
                <Button disabled={logInState === LoginState.STARTED} onClick={initAuth} variant={"outlined"}
                    style={{
                        color: 'white',
                        paddingLeft: 60,
                        marginTop: 20,
                        paddingRight: 60,
                        paddingTop: 10,
                        paddingBottom: 10,
                        borderColor: 'white',
                        borderWidth: 2
                    }}>GET STARTED</Button>
            </div>
            {
                navigateToLogin &&
                <Redirect to={Routes.LOGIN} />
            }
        </div>
    );
}